/***********************************
 * Shared GAdmin settings dialog (main portal + global.html).
 ************************************/

const LitLiteBase = window.LitLite;

export class GadminDialogView extends LitLiteBase {
    constructor(options) {
        super();
        options = options || {};
        this.abortController = new AbortController();
        this.closeCallback = options.closeCallback;
        this.userList = null;
        this.companyList = null;
        this.userSelected = null;
        this.companySelected = null;
        this.userSettings = null;

        if (DplLink.isImpersonating() && DplLink.currentCompany && DplLink.currentCompany.companyid != null) {
            this.companySelected = DplLink.currentCompany.companyid;
            this.fetchUsersList();
        }
        this.fetchCompanyList();
    }

    render() {
        const template = LH.html`
            <div class="gadminDialogView">
                <div class="closePanel">
                    <div class="ic-cancel closeGadminDialogView" title="Close" @click=${this.close}></div>
                </div>
                <div class="box-sub-hdr">
                    <div class="title txt">GAdmin Settings</div>
                </div>
                <div class="gadminDialogClone">
                    <div class="cloneCompanyHolder">
                        <label>Company</label>
                        <select name="cloneCompanySelection" class="cloneCompanySelection" @change=${this.selectCompany}>
                            ${this.companyList ? this.companyList.map(company => LH.html`
                                <option value="${company.adminid}" ?selected=${this.companySelected == company.adminid}>
                                    ${company.enabled === 0 ? '{Disabled}-' : ''}${company.companyname}
                                </option>
                            `) : LH.html``}
                        </select>
                    </div>
                    <div class="cloneUserHolder">
                        <label>User</label>
                        <select name="cloneUserSelection" class="cloneUserSelection" @change=${this.selectUser}>
                            ${this.userList ? this.userList.map(user => LH.html`
                                <option value="${user.userid}" ?selected=${this.userSelected == user.userid}>
                                    ${ user.is_account_owner ? 'Account Owner - ' : DplLink.getUserType(user.usertype, user.restricted) + ' - ' }
                                    ${user.userenabled === 0 ? '{Disabled}-' : ''}${ user.username || user.email } - ${user.displayname}
                                </option>
                            `) : LH.html``}
                        </select>
                    </div>
                    <div class="gadminDialogCloneActions">
                        <div class="btnStandard impersonate" @click=${this.impersonate}>Impersonate</div>
                        <div class="btnStandard unimpersonate" @click=${this.unimpersonate}>Un-impersonate</div>
                    </div>
                </div>
                <div class="toggleControl datamanglecnt">
                    <div class="toggleSwitch" @click=${this.toggleDatamanglecnt}>
                        <div class="toggle"></div>
                    </div>
                    <label>Mangle Data</label>
                </div>
                <div class="toggleControl hideenvbannercnt">
                    <div class="toggleSwitch" @click=${this.toggleHideEnvBanner}>
                        <div class="toggle"></div>
                    </div>
                    <label>Hide ALPHA/BETA Banner</label>
                </div>
                <div class="toggleControl hidewhatsnewcnt">
                    <div class="toggleSwitch" @click=${this.toggleSuppressWhatsNew}>
                        <div class="toggle"></div>
                    </div>
                    <label>Hide What's New</label>
                </div>
                <div class="userSettings">
                    <div class="toggleControl alldatacnt">
                        <div class="toggleSwitch" @click=${this.toggleAtmdatacnt}>
                            <div class="toggle"></div>
                        </div>
                        <label>Access All Data</label>
                    </div>
                    <div class="gadminDialogLinks">
                        <div class="btnStandard gadminPortalBtn" @click=${this.openGadminPortal}>GAdmin Portal</div>
                        ${this.canShowRebootIqDemo() ? LH.html`
                            <div class="btnStandard rebootIqDemoBtn" @click=${this.openRebootIqDemo}>RebootIQ Demo</div>
                        ` : LH.html``}
                    </div>
                </div>
            </div>
        `;
        LH.render(template, this.el, { host: this });
        this.updateGAdminSettings();
        this.updateSettings();
        return this;
    }

    updateGAdminSettings() {
        const allDataToggle = this.el.querySelector('.alldatacnt .toggle');
        if (!allDataToggle) { return; }
        if (DplLink.superuserEnabled()) {
            allDataToggle.classList.add('on');
        } else {
            allDataToggle.classList.remove('on');
        }
        const userSettings = this.el.querySelector('.userSettings');
        if (userSettings) { userSettings.style.display = 'block'; }
    }

    updateSettings() {
        const dataMangleToggle = this.el.querySelector('.datamanglecnt .toggle');
        if (dataMangleToggle) {
            if (DplLink.dataMaskSwitch) {
                dataMangleToggle.classList.add('on');
            } else {
                dataMangleToggle.classList.remove('on');
            }
        }
        const hideEnvBannerToggle = this.el.querySelector('.hideenvbannercnt .toggle');
        if (hideEnvBannerToggle) {
            if (DplLink.hideEnvBannerSwitch) {
                hideEnvBannerToggle.classList.add('on');
            } else {
                hideEnvBannerToggle.classList.remove('on');
            }
        }
        const hideWhatsNewToggle = this.el.querySelector('.hidewhatsnewcnt .toggle');
        if (hideWhatsNewToggle) {
            if (DplLink.suppressWhatsNewWhenImpersonating) {
                hideWhatsNewToggle.classList.add('on');
            } else {
                hideWhatsNewToggle.classList.remove('on');
            }
        }
    }

    close() {
        if (this.closeCallback) {
            this.closeCallback();
        }
    }

    fetchCompanyList() {
        DplLink.apiCall({
            type: 'GET',
            url: DplLink.resthost + DplLink.apiUrls.companiesForCloning,
            gadminCall: true,
            success: (response) => {
                this.companyList = response;
                this.refresh();
            }
        });
    }

    fetchUsersList() {
        if (this.companySelected) {
            DplLink.apiCall({
                type: 'GET',
                url: DplLink.resthost + DplLink.apiUrls.usersForCloning,
                data: { p1: this.companySelected },
                gadminCall: true,
                success: (response) => {
                    this.userList = response;
                    if (response.length > 0) {
                        this.userSelected = response[0].userid;
                        this.fetchUser();
                    }
                    this.refresh();
                }
            });
        } else {
            this.userList = null;
            this.userSelected = null;
            this.refresh();
        }
    }

    selectCompany(e) {
        this.companySelected = e.target.value;
        this.fetchUsersList();
    }

    selectUser(e) {
        this.userSelected = e.target.value;
        this.fetchUser();
    }

    impersonate() {
        const user = this.userSelected || this.el.querySelector('.cloneUserSelection').value;
        const company = this.companySelected || this.el.querySelector('.cloneCompanySelection').value;
        if (DplLink.Router && DplLink.Router.navigate) {
            DplLink.Router.navigate(`/impersonate/${user}/${company}`, { trigger: true });
        } else {
            window.location.href = `/#impersonate/${user}/${company}`;
        }
    }

    unimpersonate() {
        if (DplLink.isImpersonating()) {
            DplLink.resetToGenuineSelf(() => {
                DplLink.refreshOtherTabs();
                window.location.href = '/';
            });
        }
    }

    /** Open global admin portal; un-impersonate first when needed. */
    openGadminPortal() {
        const go = () => { window.location.href = '/global.html'; };
        if (DplLink.isImpersonating()) {
            DplLink.resetToGenuineSelf(() => {
                DplLink.refreshOtherTabs();
                go();
            });
            return;
        }
        go();
    }

    /**
     * Whether to surface the RebootIQ demo launcher.
     *
     * Impersonating always implies a genuine gadmin is behind the session
     * (only gadmins can impersonate), but currentUser.usertype is then the
     * impersonated user's, so DplLink.isGAdmin() returns false. Treat an active
     * impersonation as authorized so the button appears inside a customer
     * account; otherwise fall back to a non-limited gadmin check.
     */
    canShowRebootIqDemo() {
        if (DplLink.isImpersonating && DplLink.isImpersonating()) {
            return true;
        }
        return !!(DplLink.isGAdmin && DplLink.isGAdmin() &&
            !(DplLink.isLimitedGAdmin && DplLink.isLimitedGAdmin()));
    }

    /**
     * Launch the RebootIQ live demo console in a new window. Uses window.open
     * (not a navigation) so the current impersonation cookies stay intact and
     * the demo page loads scoped to the account being viewed. Never routes
     * through /global.html, which would reset to the genuine gadmin self.
     */
    openRebootIqDemo() {
        window.open('/rebootiqdemo.html', '_blank');
    }

    toggleAtmdatacnt() {
        DplLink.apiCall({
            type: 'PUT',
            url: DplLink.resthost + DplLink.apiUrls.enablesuperuser,
            data: { p1: !DplLink.superuserEnabled(), passgadmin: true },
            gadminCall: true,
            complete: () => {
                DplLink.getGadminUserOptions(() => this.updateGAdminSettings());
            }
        });
    }

    fetchUser() {
        if (this.userSelected) {
            DplLink.apiCall({
                type: 'GET',
                url: DplLink.resthost + DplLink.apiUrls.userForGadmin,
                data: { p1: this.userSelected },
                gadminCall: true,
                success: (response) => {
                    this.userSettings = response.length === 1 ? response[0] : null;
                    this.updateGAdminSettings();
                }
            });
        } else {
            this.updateGAdminSettings();
        }
    }

    toggleDatamanglecnt() {
        DplLink.setDataMaskSwitch(!DplLink.dataMaskSwitch);
        this.updateSettings();
    }

    toggleHideEnvBanner() {
        DplLink.setHideEnvBannerSwitch(!DplLink.hideEnvBannerSwitch);
        this.updateSettings();
    }

    toggleSuppressWhatsNew() {
        DplLink.setSuppressWhatsNewWhenImpersonating(!DplLink.suppressWhatsNewWhenImpersonating);
        this.updateSettings();
    }

    destroyer() {
        this.abortController.abort();
        this.el.remove();
    }
}

DplLink.GadminDialogView = GadminDialogView;
